<template>
    <div>
            <div class="score-history__item" v-if="item.amount > 0">
            <div class="column"><div class="write-on">Нарахування</div></div>
            <div class="column">{{ item.createdAt }}</div>
            <div class="column">{{ item.userFullName }}</div>
            <div class="column"><div class="write-on-amount">{{ item.amount }}</div></div>
            <div class="column">{{ item.currentAmount }}</div>
            <div class="column" v-if="item.orderType === 1"><span>Продукт:</span>ОСЦПВ ({{ item.mtsbuCode }})</div>
            <div class="column" v-else-if="item.orderType === 2"><span>Продукт:</span>Автобус ({{ item.contractId }})</div>
            <div class="column" v-else-if="item.orderType === 3"><span>Продукт:</span>Зелена Карта ({{ item.mtsbuCode }})</div>
            <div class="column" v-else-if="item.orderType === 5"><span>Продукт:</span>Туризм ({{ item.mtsbuCode }})</div>
            <div class="column" v-else-if="item.orderType === 7"><span>Продукт:</span>Ручні оформлення ({{ item.mtsbuCode }})</div>
            <div class="column" v-else-if="item.orderType === 8"><span>Продукт:</span>Страхування житла ({{ item.mtsbuCode }})</div>
            <div class="column" v-else-if="item.orderType === 9"><span>Продукт:</span>Міні КАСКО ({{ item.mtsbuCode }})</div>
            <div class="column" v-else-if="item.orderType === 12"><span>Продукт:</span>Нещасний випадок ({{ item.mtsbuCode }})</div>
            <div class="column"><span>СК:</span> {{ item.company }}</div>
            <div class="column" ><span>Джерело:</span> Використання бонусів</div>
            <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
        </div>
        <div class="score-history__item" v-else>
            <div class="column"><div class="write-off">Списання</div></div>
            <div class="column">{{ item.createdAt }}</div>
            <div class="column"></div>
            <div class="column"><div class="write-off-amount">{{ item.amount }}</div></div>
            <div class="column">{{ item.currentAmount }}</div>
            <div class="column" v-if="item.orderType === 1"><span>Продукт:</span>Списано бонусів за припиненний договір ОСЦПВ ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 2"><span>Продукт:</span>Списано бонусів за припиненний договір Автобус ({{ item.contractId }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 3"><span>Продукт:</span>Списано бонусів за припиненний договір Зелена Карта ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 5"><span>Продукт:</span>Списано бонусів за припиненний договір Туризм ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 7"><span>Продукт:</span>Списано бонусів за припиненний договір Ручні оформлення ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 8"><span>Продукт:</span>Списано бонусів за припиненний договір Страхування житла ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 9"><span>Продукт:</span>Списано бонусів за припиненний договір Міні КАСКО ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column" v-else-if="item.orderType === 12"><span>Продукт:</span>Списано бонусів за припиненний договір Нещасний випадок ({{ item.mtsbuCode }}) та повернуто в бонусний баланс</div>
            <div class="column"><span>СК:</span> {{ item.company }}</div>
            <div class="column"><span>Джерело:</span> Автосписання</div>
            <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RowBlockBonusSystem',
    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    amount: null,
                    amountDgo: null,
                    createdAt: null,
                    currentAmount: null,
                };
            },
        },
    },
}
</script>
